import React, { useContext, useState } from "react";
import {
  IconButton,
  Toolbar,
  Box,
  alpha,
  Typography,
  Chip,
  keyframes,
} from "@mui/material";
import { Menu, NotificationsActive } from "@mui/icons-material";
import NotificactionsButtons from "./NotificactionsButtons";
import AuthContext from "../../../Context/Auth/AuthContext";

const ringBell = keyframes`
  0%, 100% { transform: rotate(0deg); }
  8% { transform: rotate(18deg); }
  16% { transform: rotate(-16deg); }
  24% { transform: rotate(14deg); }
  32% { transform: rotate(-10deg); }
  40% { transform: rotate(6deg); }
  48% { transform: rotate(-3deg); }
  56% { transform: rotate(0deg); }
`;

const pulseGlow = keyframes`
  0%, 100% {
    box-shadow: 0 4px 24px rgba(0,0,0,0.2);
    transform: scale(1);
  }
  50% {
    box-shadow: 0 6px 32px rgba(0,0,0,0.35);
    transform: scale(1.03);
  }
`;

const slideInBounce = keyframes`
  0% { opacity: 0; transform: translateX(-20px) scale(0.8); }
  60% { opacity: 1; transform: translateX(4px) scale(1.04); }
  80% { transform: translateX(-2px) scale(0.98); }
  100% { opacity: 1; transform: translateX(0) scale(1); }
`;

const textPop = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.08); }
`;

const NavbarMobile = (props) => {
  const { usuario } = useContext(AuthContext);
  const { handleDrawerToggle } = props;
  const [totalNoLeidas, setTotalNoLeidas] = useState(0);

  return (
    <Toolbar
      sx={(theme) => ({
        background: totalNoLeidas > 0
          ? `linear-gradient(to right, ${alpha(theme.palette.primary.main, 0.12)}, ${alpha(theme.palette.primary.main, 0.05)})`
          : theme.palette.background.paper,
        borderBottom: `1px solid ${alpha(
          totalNoLeidas > 0 ? theme.palette.primary.main : theme.palette.divider,
          totalNoLeidas > 0 ? 0.3 : 0.08,
        )}`,
        transition: "background 0.4s ease, border-color 0.4s ease",
      })}
    >
      <IconButton
        aria-label="open drawer"
        edge="start"
        onClick={handleDrawerToggle}
        sx={{
          mr: 1.5,
          borderRadius: 2,
          color: (t) =>
            totalNoLeidas > 0
              ? t.palette.primary.contrastText
              : t.palette.text.primary,
          "&:hover": {
            backgroundColor: (theme) =>
              alpha(theme.palette.primary.main, 0.08),
          },
        }}
      >
        <Menu />
      </IconButton>

      {totalNoLeidas > 0 && (
        <Box
          sx={{
            animation: `${slideInBounce} 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)`,
            display: "flex",
            alignItems: "center",
            gap: 0.8,
            backgroundColor: (t) => t.palette.primary.main,
            color: (t) => t.palette.primary.contrastText,
            py: 0.6,
            px: 1.5,
            borderRadius: 50,
            animationDuration: "0.6s, 2s",
            animationName: `${slideInBounce}, ${pulseGlow}`,
            animationIterationCount: "1, infinite",
            animationTimingFunction: "cubic-bezier(0.34,1.56,0.64,1), ease-in-out",
            cursor: "pointer",
            userSelect: "none",
            flexShrink: 0,
          }}
        >
          <NotificationsActive
            sx={{
              fontSize: "1.1rem",
              animation: `${ringBell} 2s ease-in-out infinite`,
            }}
          />
          <Typography
            sx={{
              fontWeight: 800,
              fontSize: "0.85rem",
              color: (t) => t.palette.primary.contrastText,
              animation: `${textPop} 2.5s ease-in-out infinite`,
              letterSpacing: -0.3,
              whiteSpace: "nowrap",
            }}
          >
            {totalNoLeidas} nueva{totalNoLeidas > 1 ? "s" : ""}
          </Typography>
        </Box>
      )}

      <Box
        display="flex"
        justifyContent="flex-end"
        alignItems="center"
        width="100%"
      >
        <NotificactionsButtons
          mobile
          onNotificacionesChange={setTotalNoLeidas}
        />
      </Box>
    </Toolbar>
  );
};

export default NavbarMobile;
